// extracted by mini-css-extract-plugin
export default {"locationCell":"WagonsReportTable_locationCell__YgLEi","weightCell":"WagonsReportTable_weightCell__NkIEN","container":"WagonsReportTable_container__m7KXw"};